import {
  Button,
  Divider,
  FormErrorMessage,
  Heading,
  Input,
  Spinner,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import CardForm from "../../../components/CardForm";
import {
  Setting,
  SetttingGroup,
  useAllGroupSettingsQuery,
  useSaveSettingsMutation,
} from "../../../generated/graphql";

import ResponsiveFormControl from "../../../components/ResponsiveFormControl";
import { useForm } from "react-hook-form";
import { IFormSetting } from "./interface";
import { useEffect } from "react";
import CardFormTitle from "../../../components/CardForm/CardFormTitle";

const InvoiceSetting: React.FC = () => {
  const { data, loading: loadingData } = useAllGroupSettingsQuery({
    variables: {
      group: SetttingGroup.InvoiceSetting,
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<IFormSetting>();

  useEffect(() => {
    const obj: { [key: string]: Setting } = {};

    data?.allGroupSettings.forEach((elm) => {
      obj[elm.key] = elm;
    });

    reset({
      paymentCompanyName: obj["paymentCompanyName"]?.value,
      paymentBranchName: obj["paymentBranchName"]?.value,
      paymentBankNo: obj["paymentBankNo"]?.value,
      paymentSwiftCode: obj["paymentSwiftCode"]?.value,
      paymentAccountCode: obj["paymentAccountCode"]?.value,
      importantNotes: obj["importantNotes"]?.value,
    });
  }, [data]);

  const toast = useToast();

  const [saveSettings, { loading }] = useSaveSettingsMutation();

  const onSubmit = async (data: IFormSetting) => {
    try {
      await saveSettings({
        variables: {
          input: {
            group: SetttingGroup.InvoiceSetting,
            settings: [
              {
                key: "paymentCompanyName",
                value: data.paymentCompanyName,
              },
              {
                key: "paymentBranchName",
                value: data.paymentBranchName,
              },
              {
                key: "paymentBankNo",
                value: data.paymentBankNo,
              },
              {
                key: "paymentSwiftCode",
                value: data.paymentSwiftCode,
              },
              {
                key: "paymentAccountCode",
                value: data.paymentAccountCode,
              },
              {
                key: "importantNotes",
                value: data.importantNotes,
              },
            ],
          },
        },
      });

      toast({ status: "success", description: "Settings saved successfully!" });
    } catch (e) {
    } finally {
    }
  };

  if (loadingData) {
    return <Spinner />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <CardForm maxW="container.xl">
        <CardFormTitle>Invoice Settings</CardFormTitle>

        <Heading as="h3" fontSize="lg" mb={4} mt={10}>
          Important Notes
        </Heading>
        <ResponsiveFormControl
          label="Important Notes"
          isRequired
          isInvalid={errors.importantNotes ? true : false}
          messageComponents={
            <FormErrorMessage>Important Notes is required!</FormErrorMessage>
          }
        >
          <Textarea {...register("importantNotes", { required: true })} />
        </ResponsiveFormControl>
        <Button type="submit" isLoading={loading}>
          Save Settings
        </Button>
      </CardForm>
    </form>
  );
};

export default InvoiceSetting;
